import { useHistory } from 'react-router';

import { isVerificationAccount } from '@app/redux/auth/auth.selectors';
import { useAppSelector } from '@app/redux/hooks';
import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import KeyIcon from '@mui/icons-material/Key';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import QrCodeIcon from '@mui/icons-material/QrCode';

import MFA_METHODS_ENUM from '../../../enums/MFA_METHODS.enum';

export const useMFAMethodsInfo = ({
	availableMFAMethods,
	isUnauthenticated,
}: {
	availableMFAMethods?: MFA_METHODS_ENUM[];
	isUnauthenticated?: boolean;
}) => {
	const { isEmailVerified, isPhoneVerified } = useAppSelector(isVerificationAccount);
	const generateRoutePath = useGenerateRoutePath();
	const history = useHistory();

	const switchToEmail = () => {
		history.push(
			isEmailVerified || isUnauthenticated
				? history.location.pathname
				: generateRoutePath(RoutePaths.VERIFICATION.ACCOUNT),
			{ selectedMFA: MFA_METHODS_ENUM.EMAIL },
		);
	};

	const switchToPhone = () => {
		history.push(
			isPhoneVerified || isUnauthenticated
				? history.location.pathname
				: generateRoutePath(RoutePaths.VERIFICATION.ACCOUNT),
			{ selectedMFA: MFA_METHODS_ENUM.SMS },
		);
	};

	const switchToWebauthn = () => history.push(history.location.pathname, { selectedMFA: MFA_METHODS_ENUM.WEBAUTHN });
	const switchToTotp = () => history.push(history.location.pathname, { selectedMFA: MFA_METHODS_ENUM.TOTP });

	const switchToMFA = {
		[MFA_METHODS_ENUM.WEBAUTHN]: switchToWebauthn,
		[MFA_METHODS_ENUM.EMAIL]: switchToEmail,
		[MFA_METHODS_ENUM.SMS]: switchToPhone,
		[MFA_METHODS_ENUM.TOTP]: switchToTotp,
	};
	const Icons = {
		[MFA_METHODS_ENUM.EMAIL]: MailOutlineIcon,
		[MFA_METHODS_ENUM.SMS]: PhoneIphoneIcon,
		[MFA_METHODS_ENUM.WEBAUTHN]: KeyIcon,
		[MFA_METHODS_ENUM.TOTP]: QrCodeIcon,
	};

	return (availableMFAMethods ?? Object.values(MFA_METHODS_ENUM)).map(mfa => ({
		onClick: switchToMFA[mfa],
		Icon: Icons[mfa],
		method: mfa,
	}));
};
